import { connect } from 'react-redux';
import QuickApp from '../../../modules/quickapp/QuickApp';
import {
  subscribeToGenesysChatState,
  unsubscribeToGenesysChatState,
  subscribeToGenesysCobrowseState,
  unsubscribeToGenesysCobrowseState,
  subscribeToGenesysTextState,
  unsubscribeToGenesysTextState,
} from '../../domains/vendor/genesys/actions';
import withService from '../../../components/hoc/withService';

const mapStateToProps = state => ({
  pageURL: state.router?.location?.pathname,
});

const quickAppWithService = withService(QuickApp);

const mapDispatchToProps = dispatch => ({
  subscribeToGenesysChatState: () => dispatch(subscribeToGenesysChatState()),
  unsubscribeToGenesysChatState: () => dispatch(unsubscribeToGenesysChatState()),
  subscribeToGenesysCobrowseState: () => dispatch(subscribeToGenesysCobrowseState()),
  unsubscribeToGenesysCobrowseState: () => dispatch(unsubscribeToGenesysCobrowseState()),
  subscribeToGenesysTextState: () => dispatch(subscribeToGenesysTextState()),
  unsubscribeToGenesysTextState: () => dispatch(unsubscribeToGenesysTextState()),
});

export default connect(mapStateToProps, mapDispatchToProps)(quickAppWithService);
